import React, { FunctionComponent, useEffect, useState } from 'react'

import styled from 'styled-components'

import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'

import Logo from '../Home/components/Logo'
// import Animations from '../Home/components/Animations'

type Circle = {
  scrollFactor: number
}

const Circle = styled.div<Circle>`
  ${({ scrollFactor, theme: { palette } }) => `
    background: url('./assets/pattern-x3.png'), linear-gradient(45deg, ${
      palette.secondary.main
    }, ${palette.secondary.main} 50%, ${palette.primary.main});
    background-attachment: fixed;
    border-radius: 240px;
    position: Fixed;
    top: -200px;
    right: -200px;
    width: 480px;
    height: 480px;
    transition: transform 0.3s ease-out;
    transform:translateX(${scrollFactor * 100}px) translateY(-${
    scrollFactor * 100
  }px);
    &:hover {
      transform: translateX(0) translateY(0);
    }
    
  `}
`

const PageContent = styled.div`
  background: #fff;
  margin: 0 auto 0;
  width: 1000px;
  padding: 64px;
`

const Story: FunctionComponent = () => {
  const [scrollFactor, setScrollFactor] = useState(0)

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (Math.min(window.scrollY / 1000, 1) < 1) {
        setScrollFactor(Math.min(window.scrollY / 1000, 1))
      }
    })
  })

  return (
    <div style={{ background: '#fff', position: 'relative' }}>
      {/* <Animations /> */}
      <Circle scrollFactor={scrollFactor}></Circle>
      <PageContent>
        <Typography variant="h1">
          Über <Logo />
        </Typography>
        <Box my={4} />
        <Typography variant="h3">Geschichte</Typography>
        <Box my={2} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
              amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et dolore magna aliquyam erat, sed diam
              voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
              Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum
              dolor sit amet.
            </Typography>
            <Box my={2} />
            <Typography>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
              amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et dolore magna aliquyam erat, sed diam
              voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
              Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum
              dolor sit amet.
            </Typography>
          </Grid>
        </Grid>
        <Box my={8} />
        <Grid container spacing={2}>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <Typography variant="h3">Die Unterstützer</Typography>
            <Box my={2} />
            <Typography>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
              amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et dolore magna aliquyam erat, sed diam
              voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
              Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum
              dolor sit amet.
            </Typography>
          </Grid>
        </Grid>
        <Box my={8} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="h3">Das Team</Typography>
            <Box my={2} />
            <Typography>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
              amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et dolore magna aliquyam erat, sed diam
              voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
              Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum
              dolor sit amet.
            </Typography>
          </Grid>
          <Grid item xs={6}></Grid>
        </Grid>
      </PageContent>
    </div>
  )
}

export default Story
